import $ from 'jquery';

function initContestOrganizerEdit() {
  const editForm = document.querySelector('.contest-organizer-edit');

  if (!editForm) {
    return;
  }

  const moderatorCheckBox = editForm.querySelector('[name="moderator"]');

  if (!moderatorCheckBox) {
    return;
  }

  moderatorCheckBox.addEventListener('change',  async function (e) {
    if (!e.target.checked) {
      return;
    }

    e.preventDefault();

    const modalSelector = '#paid-settings-modal[data-event-source-id="moderator-checkbox"]';
    const paidSettingsModal = document.querySelector(modalSelector);

    if (!paidSettingsModal) {
      moderatorCheckBox.checked = false;

      return false;
    }

    const url  = paidSettingsModal.getAttribute('data-check-contest-paid-url');

    const response = await fetch(url);
    const result = await response.json();

    if (result.status === 'success') {
      const moderatorNominationsBlock = editForm.querySelector('#moderator_nominations');
      let disableParam;

      if (moderatorCheckBox.checked) {
        moderatorNominationsBlock.classList.remove('d-none');
        disableParam = false;
      } else {
        moderatorNominationsBlock.classList.add('d-none');
        disableParam = true;
      }

      const nominationsCheckboxes = moderatorNominationsBlock.querySelectorAll('input[name="categories[]"]');
      nominationsCheckboxes.forEach(function (element) {
        element.disabled = disableParam;
      });

      return true;
    } else {
      const overlay = $('#overlay');
      overlay.addClass('cabinet-contest-modal');
      overlay.fadeIn();
      paidSettingsModal.classList.add('active');
      moderatorCheckBox.checked = false;

      return false;
    }
  });
}

export { initContestOrganizerEdit }